__turbopack_context__.v({
  "className": "space_grotesk_f4d932a1-module__tDzxSa__className",
});
